import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Shield, Server, Cpu, Zap } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";

const ENTERPRISE_ITEMS = [
  {
    titleKey: "eep.prodArchTitle",
    icon: Server,
    detailKeys: ["eep.prodArch1", "eep.prodArch2", "eep.prodArch3", "eep.prodArch4", "eep.prodArch5"],
  },
  {
    titleKey: "eep.secureInfraTitle",
    icon: Shield,
    detailKeys: ["eep.secureInfra1", "eep.secureInfra2", "eep.secureInfra3", "eep.secureInfra4", "eep.secureInfra5"],
  },
  {
    titleKey: "eep.enterpriseDeployTitle",
    icon: Cpu,
    detailKeys: ["eep.enterpriseDeploy1", "eep.enterpriseDeploy2", "eep.enterpriseDeploy3", "eep.enterpriseDeploy4", "eep.enterpriseDeploy5"],
  },
  {
    titleKey: "eep.aiAutomationTitle",
    icon: Zap,
    detailKeys: ["eep.aiAutomation1", "eep.aiAutomation2", "eep.aiAutomation3", "eep.aiAutomation4"],
  },
];

export function EnterpriseExpandablePanel() {
  const { t } = useI18n();
  return (
    <Accordion type="single" collapsible className="space-y-3">
      {ENTERPRISE_ITEMS.map((item) => (
        <AccordionItem
          key={item.titleKey}
          value={item.titleKey}
          className="rounded-xl border border-border/40 bg-card/40 backdrop-blur px-5 data-[state=open]:border-primary/30 transition-colors"
        >
          <AccordionTrigger className="hover:no-underline py-4">
            <div className="flex items-center gap-3">
              <item.icon className="h-5 w-5 text-primary flex-shrink-0" />
              <span className="text-sm font-medium text-foreground text-left">{t(item.titleKey)}</span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="pb-4">
            <div className="space-y-2 pl-8">
              {item.detailKeys.map((dk) => (
                <div key={dk} className="flex items-start gap-2">
                  <div className="h-1.5 w-1.5 rounded-full bg-primary mt-1.5 flex-shrink-0" />
                  <span className="text-sm text-muted-foreground">{t(dk)}</span>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
